import { Button, Icon } from "@elaniintc/goes-design-system";
import SearchInput from "../search-input";
import Tab from "@/components/ui/tab";
import { PulseIndicator } from "../pulse-indicator";

interface Props {
  tabs: {
    label: string;
    value: string;
  }[];
  title?: string;
  activeTab?: string; // the currently active tab value
  onTabChange: (value: string) => void;
  isLoading?: boolean; // whether the table data is currently being fetched or updated
  search: string | null;
  setSearch: (value: string | null) => void;
  canCreate?: boolean;
  createLabel: string;
  onCreate?: () => void;
  onFilter: () => void;
  filtersApplied: number;
  placeholder?: string;
}

const TableHeaderWithTab = ({
  tabs,
  title,
  activeTab,
  onTabChange,
  canCreate,
  onCreate,
  createLabel,
  search,
  setSearch,
  isLoading,
  onFilter,
  filtersApplied,
  placeholder,
}: Props) => {
  return (
    <div className="rounded-t-lg bg-neutral-object px-3 pt-3 w-full flex gap-0 items-center justify-between">
      <div>
        {tabs.map(({ label, value }) => {
          return (
            <Tab
              key={value}
              active={value === activeTab}
              onClick={() => onTabChange(value)}
            >
              {label}
            </Tab>
          );
        })}
        {isLoading && (
          <Icon
            type="far"
            name="spinner-third"
            className="animate-spin text-on-disabled"
          />
        )}
        {title && <h2 className="text-lg font-semibold pb-3">{title}</h2>}
      </div>
      <div className="flex items-center gap-2 pb-3">
        <div className="hidden md:inline">
          <SearchInput
            variant="xs"
            placeholder={placeholder || "Buscar..."}
            data-testid="search-input"
            className="w-60 text-sm"
            value={search || ""}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <Button
          className="md:hidden"
          aria-label="Buscar"
          size="icon"
          variant="quiet"
        >
          <Icon type="far" name="search" className="" />
        </Button>

        <Button
          data-testid="filter-button"
          size="xs"
          variant="quiet"
          type="button"
          onClick={onFilter}
          className="relative"
        >
          <span className="hidden md:inline-block">Filtros</span>
          <Icon type="far" name="filter" className="text-current" />
          <PulseIndicator showIndicator={filtersApplied > 0} />
        </Button>

        {canCreate && (
          <Button size="xs" onClick={onCreate}>
            <span className="hidden md:inline-block">{createLabel}</span>
            <Icon type="far" name="plus" className="text-current" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableHeaderWithTab;
